import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/news";

const values = [
  { icon: "ri-flashlight-line", title: "快", text: "滚动更新，重要进展几分钟内上线。" },
  { icon: "ri-shield-check-line", title: "准", text: "待核实信息明确标注，后续持续补充。" },
  { icon: "ri-stack-line", title: "全", text: "快讯之外补充背景，把一件事讲清楚。" },
];

export default function AboutBand() {
  return (
    <section aria-label="关于我们" className="border-y border-background-200 bg-background-100">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-8 px-4 py-12 md:px-6 lg:grid-cols-[1fr_1.2fr] lg:gap-16">
        <div>
          <span className="text-xs font-medium tracking-widest text-primary-500">
            ABOUT {siteInfo.name}
          </span>
          <h2 className="mt-3 font-serif-cn text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            {siteInfo.slogan}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">{siteInfo.intro}</p>
          <Link
            to="/about"
            className="mt-5 inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-5 py-2.5 text-sm text-background-50 transition hover:bg-primary-600"
          >
            了解平台与内容原则
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
          {values.map((item) => (
            <div
              key={item.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                <i className={`${item.icon} text-xl`} />
              </span>
              <p className="mt-4 font-serif-cn text-lg font-bold text-foreground-950">
                {item.title}
              </p>
              <p className="mt-1.5 text-sm text-foreground-600">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}